// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"8cd86f4b","704":"23c94fd1"}[chunkId] + ".chunk.js";
};